import { INewsArticleList } from './interfaces';

export default (): IGameState => ({
  listPending: true,
  matchups: null,
  personalisedMatchups: null,
  newsArticles: { panels: [] } as INewsArticleList,
});
